'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var nthBitHeader = require('@narvar/nth-bit-header');
var ActionButtonsContainer = require('./ActionButtonsContainer.js');
var Box = require('./Box/Box.js');
var Markdown = require('../Markdown/Markdown.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const DesktopWorkflowContent = styled__default["default"].div.withConfig({
  componentId: "sc-wf4q8h-0"
})(["display:grid;grid-template-columns:1fr 1.5fr;grid-gap:1rem;max-width:38.5rem;margin:0 auto;"]);
const DesktopWorkflowContentLeft = styled__default["default"].div.withConfig({
  componentId: "sc-wf4q8h-1"
})(["display:flex;justify-content:center;"]);
const DesktopWorkflowContentHeader = _ref => {
  let {
    title,
    subtitle
  } = _ref;
  if (!title) return null;
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2,
    style: {
      textAlign: 'center',
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "h1"
  }, title), subtitle && /*#__PURE__*/React__default["default"].createElement(Markdown["default"], {
    markdown: subtitle
  }));
};
const DesktopWorkflowContentActionButtonsContainer = styled__default["default"](ActionButtonsContainer["default"]).withConfig({
  componentId: "sc-wf4q8h-2"
})(["padding-top:2rem;"]);
const DesktopWorkflowContentRight = styled__default["default"].div.withConfig({
  componentId: "sc-wf4q8h-3"
})([""]);

exports.DesktopWorkflowContent = DesktopWorkflowContent;
exports.DesktopWorkflowContentActionButtonsContainer = DesktopWorkflowContentActionButtonsContainer;
exports.DesktopWorkflowContentHeader = DesktopWorkflowContentHeader;
exports.DesktopWorkflowContentLeft = DesktopWorkflowContentLeft;
exports.DesktopWorkflowContentRight = DesktopWorkflowContentRight;
